import { MicrosoftTenantCard } from "@/components/settings/microsoft-tenant-card.tsx";
import { OrganizationOverview } from "@/components/settings/organization-overview.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";
import { RoutePending } from "@/components/custom/route-pending.tsx";

export const Route = createFileRoute("/_authenticated/settings/org/overview")({
	component: RouteComponent,
	pendingComponent: RoutePending,
	head: () => ({
		meta: [{ title: pageTitle(m.settings_workspace_overview()) }],
	}),
});

function RouteComponent() {
	return (
		<div className="space-y-6">
			<OrganizationOverview />
			<MicrosoftTenantCard />
		</div>
	);
}
